interface ProgramTheme {
  iconBg: string;
  color: string;
  tagColor: string;
}

export const PROGRAM_THEME: Record<string, ProgramTheme> = {
  green: { iconBg: "bg-green-700", color: "bg-green-50 border-green-200", tagColor: "bg-green-100 text-green-800" },
  amber: { iconBg: "bg-amber-500", color: "bg-amber-50 border-amber-200", tagColor: "bg-amber-100 text-amber-800" },
  orange: { iconBg: "bg-orange-500", color: "bg-orange-50 border-orange-200", tagColor: "bg-orange-100 text-orange-800" },
  blue: { iconBg: "bg-blue-600", color: "bg-blue-50 border-blue-200", tagColor: "bg-blue-100 text-blue-800" },
  purple: { iconBg: "bg-purple-600", color: "bg-purple-50 border-purple-200", tagColor: "bg-purple-100 text-purple-800" },
  rose: { iconBg: "bg-rose-500", color: "bg-rose-50 border-rose-200", tagColor: "bg-rose-100 text-rose-800" },
};

interface OrgTheme {
  iconColor: string;
  bg: string;
}

export const ORG_THEME: Record<string, OrgTheme> = {
  green: { iconColor: "text-green-700", bg: "bg-green-50" },
  blue: { iconColor: "text-blue-700", bg: "bg-blue-50" },
  amber: { iconColor: "text-amber-600", bg: "bg-amber-50" },
  orange: { iconColor: "text-orange-600", bg: "bg-orange-50" },
  red: { iconColor: "text-red-600", bg: "bg-red-50" },
  purple: { iconColor: "text-purple-600", bg: "bg-purple-50" },
};

const CATEGORY_COLORS = [
  "bg-green-100 text-green-700",
  "bg-amber-100 text-amber-700",
  "bg-blue-100 text-blue-700",
  "bg-purple-100 text-purple-700",
  "bg-gray-100 text-gray-600",
];

export function getCategoryColor(categoryId: number): string {
  return CATEGORY_COLORS[categoryId % CATEGORY_COLORS.length];
}
